import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { IShopSubscriberRequirement } from '@x/ecommerce/shop-client';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubscriberState } from '../state/subscriber.state';
import { InvalidRequirement, RequirementCode, TRANSLATION_MAP } from './subscriber-requirement';

@Injectable()
export class SubscriberRequirementService {
  observeRequirements$: Observable<Array<IShopSubscriberRequirement>> = this.store.select(
    SubscriberState.requirements,
  );

  findRequirementsByCode(keys: Array<RequirementCode>): Observable<Array<InvalidRequirement>> {
    return combineLatest([this.observeInvalidRequirements$]).pipe(
      map(([invalidRequirements]) => {
        const invalidCodes = invalidRequirements.filter((r) =>
          keys.includes(r.code as RequirementCode),
        );
        const invalidKeys = invalidCodes.map(({ code }) => code as RequirementCode);
        if (invalidCodes.length > 0) {
          return this.getRequirementsTranslation(invalidKeys);
        }
        return [];
      }),
    );
  }

  observeInvalidRequirements$: Observable<Array<IShopSubscriberRequirement>> =
    this.observeRequirements$.pipe(map((requirements) => requirements.filter((r) => !r.isValid)));

  getRequirementsTranslation(codes: Array<RequirementCode>): Array<InvalidRequirement> {
    return codes.map((code) => TRANSLATION_MAP[code]);
  }

  requirementsMet(requirements: Array<IShopSubscriberRequirement>): boolean {
    if (!requirements) return true;

    return requirements.some((r) => !r.isValid);
  }

  constructor(private store: Store) {}
}
